import { Component } from '@angular/core';
import { Input, Output, EventEmitter } from '@angular/core';
import { NgForm, ControlContainer, NgModelGroup } from '@angular/forms';

/**
 * Component providing a collection of system metadata edit fields.
 * See EditFieldComponent for individual field implementation.
 */
@Component({
	selector: 'edit-field-collection',
	templateUrl: './edit-field-collection.component.html',
	styleUrl: './edit-field-collection.component.css',
	viewProviders: [{ provide: ControlContainer, useExisting: NgForm }]
})
export class EditFieldCollectionComponent {
	@Input() parentForm!: NgForm;
	@Input() fields: any[] = [];
	@Input() values: { [key: string]: any } = {};
	@Output() triggerBrowseEdit = new EventEmitter<{ fieldName: string, index: number }>();
	@Output() triggerGeotag = new EventEmitter<{ fieldName: string, index: number }>();

	constructor() { }

	// Bound in the template
	onGeotag(fieldName: string, index: number): void {
		this.triggerGeotag.emit({fieldName: fieldName, index: index});
	}

	// Bound in the template
	onBrowseEdit(fieldName: string, index: number): void {
		this.triggerBrowseEdit.emit({fieldName: fieldName, index: index});
	}

	trackByField(index: number, field: any): any {
		return field.name;
	}
}
